import React, { createContext, useState, useContext, ReactNode } from 'react';

interface TransactionType {
    label: string;
    value: string;
}

interface FilterContextType {
    passyear: string;
    passmonth: string;
    DonationType: string;
    DonationPurpose: string;
    setpassyear: (value: string) => void;
    setpassmonth: (value: string) => void;
    setDonationType: (value: string) => void;
    setDonationPurpose: (value: string) => void;
    chooseyear: string;
    choosemonth: string;
    choosedonationtype: string;
    choosedonationpurpose: string;
    setchooseyear: (value: string) => void;
    setchoosemonth: (value: string) => void;
    setchoosedonationtype: (value: string) => void;
    setchoosedonationpurpose: (value: string) => void;
    transactionTypes: TransactionType[];
    setTransactionTypes: (types: TransactionType[]) => void;
    year: string;
    month: string;
    setyear: (value: string) => void;
    setmonth: (value: string) => void;

}

const FilterContext = createContext<FilterContextType | undefined>(undefined);

const FilterProvider = ({ children }: { children: ReactNode }) => {

    const [year, setyear] = useState<string>("");
    const [month, setmonth] = useState<string>("");


    const [passyear, setpassyear] = useState<string>("");
    const [passmonth, setpassmonth] = useState<string>("");
    const [DonationType, setDonationType] = useState<string>("");
    const [DonationPurpose, setDonationPurpose] = useState<string>("");

    const [chooseyear, setchooseyear] = useState<string>("");
    const [choosemonth, setchoosemonth] = useState<string>("");
    const [choosedonationtype, setchoosedonationtype] = useState<string>("");
    const [choosedonationpurpose, setchoosedonationpurpose] = useState<string>("");
    const [transactionTypes, setTransactionTypes] = useState<TransactionType[]>([]);

    return (
        <FilterContext.Provider
            value={{
                passyear,
                passmonth,
                DonationType,
                DonationPurpose,
                setpassyear,
                setpassmonth,
                setDonationType,
                setDonationPurpose,
                chooseyear,
                choosemonth,
                choosedonationtype,
                choosedonationpurpose,
                setchooseyear,
                setchoosemonth,
                setchoosedonationtype,
                setchoosedonationpurpose,
                transactionTypes,
                setTransactionTypes,
                year,
                month,
                setyear,
                setmonth,
            }}
        >
            {children}
        </FilterContext.Provider>
    );
};


export const useFilterContext = () => {
    const context = useContext(FilterContext);
    if (!context) {
        throw new Error("useFilterContext must be used within a FilterProvider");
    }
    return context;
};

export default FilterProvider;
